import React from "react";

export function SocialIcon({
                               url,
                               label,
                               size = 36,
                               path,
                               className
                           }) {
    const sharedProps = {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": label,
        title: label,
    };

    return (
        <a
            {...sharedProps}
            className={`transition-colors hover:opacity-80 ${className}`}
            style={{width: size, height: size}}
        >
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d={path}/>
            </svg>
        </a>
    );
}
